import { Dispatch, SetStateAction, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from "redux/hooks";
import { Apperance, DeleteConversation, EarnAsAffiliate, LanguageIcon, Manage, ManagePlan, OpenNewTabIcon, RequestFeature, Signout, SubOptionArrow, UsageAccount } from '../icons/SidebarDropdownSVG';
import styles from "./SidebarSubOption.module.scss";
import classNames from 'classnames';
import { RoutePaths } from 'pages/routePaths';
import useRouter from "hooks/useRouter";
import { ApperanceSubOptions } from './components/ApperanceSubOptions';
import { LanguageSubOptions } from './components/LanguageSubOptions';
import { useAppNotification } from "hooks/services/AppNotification";
import { logout } from "redux/actions";
import MixpanelAnalytics from "utils/mixpanel";
import links from "core/links";
interface IProp {
  setShowReferralModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowConfirmModel: Dispatch<SetStateAction<boolean>>;
}
const SidebarSubOption = ({
  setShowConfirmModel
}: IProp) => {
  const { push } = useRouter();
  const [openDropdown, setOpenDropdown] = useState<string | null>(null); 
  const { PrivateChat } = useSelector((state) => state.chatReducer);
  const { showCreateWorkspace } = useSelector((state) => state.workSpaceReducer);
  const { userDetail, theme } = useSelector((state) => state.authReducer);
  const { triggerNotification } = useAppNotification();
  const toggleDropdown = (dropdownName: string) => {
    if (openDropdown === dropdownName) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown(dropdownName);
    }
  };

  const onLogout = () => {
    MixpanelAnalytics.trackLogout();
    logout()
      .then(() => {
        localStorage.removeItem('email');
        window.postMessage({ logout: true });
        MixpanelAnalytics.reset();
      })
      .catch((err: any) => {
        triggerNotification({ message: err?.data?.message, type: "error" });
      });
  };

  return (
    <>

      <div className="w-full max-w-md rounded-lg p-[12px]">
        <div className={classNames("font-inter ", styles.emailStyle, {
          [styles.light]: theme === "light",
          [styles.dark]: theme === "dark",
        })}>{userDetail?.user?.email}</div>

        <div className="pt-[12px] flex flex-col gap-1">
          {/* Menu Items */}
          <div className={`flex items-center space-x-4 p-2 hover:bg-[#EDF4FE] dark:hover:bg-[#2A3249] rounded-md cursor-pointer ${(PrivateChat || showCreateWorkspace) ? styles.isbackdrop : ""}`}
            onClick={() => push(`/${RoutePaths.Settings}/${RoutePaths.Account}`)}
          >
            <div className="text-gray-600 dark:text-gray-300 flex flex-row items-center justify-center">
              <UsageAccount theme={theme} />
            </div>
            <div className={classNames("font-inter ", styles.itemText, {
              [styles.light]: theme === "light",
              [styles.dark]: theme === "dark",
            })}>
              <FormattedMessage id="sidebar.dropdown.option1" />
            </div>
          </div>


          {(userDetail?.user.team.role === "admin") && (
          <div className={`flex items-center space-x-4 p-2 hover:bg-[#EDF4FE] dark:hover:bg-[#2A3249] rounded-md cursor-pointer ${(PrivateChat || showCreateWorkspace) ? styles.isbackdrop : ""}`}
            onClick={() => push(`/${RoutePaths.Settings}/${RoutePaths.Team}`)}>
            <div className="text-gray-600 dark:text-gray-300 flex flex-row items-center justify-center">
              <Manage theme={theme} />
            </div>
            <div className={classNames("font-inter ", styles.itemText, {
              [styles.light]: theme === "light",
              [styles.dark]: theme === "dark",
            })}>
              <FormattedMessage id="sidebar.dropdown.option2" />
            </div>
          </div>
)}
 {(userDetail?.user.team.role === "admin") && (
          <div className={`flex items-center space-x-4 p-2 hover:bg-[#EDF4FE] dark:hover:bg-[#2A3249] rounded-md cursor-pointer ${(PrivateChat || showCreateWorkspace) ? styles.isbackdrop : ""}`}
            onClick={() => push(`/${RoutePaths.Settings}/${RoutePaths.CurrentPlan}`)}>
            <div className="text-gray-600 dark:text-gray-300 flex flex-row items-center justify-center">
              <ManagePlan theme={theme} />
            </div>
            <div className={classNames("font-inter ", styles.itemText, {
              [styles.light]: theme === "light",
              [styles.dark]: theme === "dark",
            })}>
              <FormattedMessage id="sidebar.dropdown.option3" />
            </div>
          </div>
)}

          {/* Language Option */}
          <div className="relative">
            <div
              className={`flex items-center justify-between p-2 hover:bg-[#EDF4FE] dark:hover:bg-[#2A3249] rounded-md cursor-pointer ${(PrivateChat || showCreateWorkspace) ? styles.isbackdrop : ""}`}
              onClick={() => toggleDropdown('language')}
            >
              <div className="flex items-center space-x-4">
                <div className="text-gray-600 dark:text-gray-300 flex flex-row items-center justify-center">
                  <LanguageIcon theme={theme} />
                </div>
                <div className={classNames("font-inter ", styles.itemText, {
                  [styles.light]: theme === "light",
                  [styles.dark]: theme === "dark",
                })}>
                  <FormattedMessage id="navbar.chat.ddMenu.language" />
                </div>
              </div>
              <div className="text-gray-600 dark:text-gray-300 flex flex-row items-center justify-center">
                <SubOptionArrow theme={theme} />
              </div>
            </div>

            {/* Language Dropdown Content */}
            {openDropdown === 'language' && (
              <LanguageSubOptions onSelect={() => setOpenDropdown(null)} />
            )}
          </div>

          {/* Appearance Option */}
          <div className="relative">
            <div
              className="flex items-center justify-between p-2 hover:bg-[#EDF4FE] dark:hover:bg-[#2A3249] rounded-md cursor-pointer"
              onClick={() => toggleDropdown('appearance')}
            >
              <div className="flex items-center space-x-4">
                <div className="text-gray-600 dark:text-gray-300 flex flex-row items-center justify-center">
                  <Apperance theme={theme} />
                </div>
                <div className={classNames("font-inter ", styles.itemText, {
                  [styles.light]: theme === "light",
                  [styles.dark]: theme === "dark",
                })}>
                  <FormattedMessage id="sidebar.dropdown.option4" />
                </div>
              </div>
              <div className="text-gray-600 dark:text-gray-300 flex flex-row items-center justify-center">
                <SubOptionArrow theme={theme} />
              </div>
            </div>

            {/* Appearance Dropdown Content */}
            {openDropdown === 'appearance' && (
              <ApperanceSubOptions onSelect={() => setOpenDropdown(null)} />
            )}
          </div>

          <a
            href={`/${RoutePaths.Affiliate}`}
            target="_blank"
            rel="noopener noreferrer"
            className={`no-underline ${(PrivateChat || showCreateWorkspace) ? styles.isbackdrop : ""}`}
          >
            <div className="flex items-center justify-between p-2 hover:bg-[#EDF4FE] dark:hover:bg-[#2A3249] rounded-md cursor-pointer">
              <div className="flex items-center space-x-4">
                <div className="text-gray-600 dark:text-gray-300 flex flex-row items-center justify-center">
                  <EarnAsAffiliate theme={theme} />
                </div>
                <div className={classNames("font-inter ", styles.itemText, {
                  [styles.light]: theme === "light",
                  [styles.dark]: theme === "dark",
                })}>
                  <FormattedMessage id="sidebar.settings.earnAsAffiliate" />
                </div>
              </div>
              <div className="text-gray-600 dark:text-gray-300 flex flex-row items-center justify-center">
                <OpenNewTabIcon theme={theme} />
              </div>
            </div>
          </a>
          <a
            href={links.FeatureRequest}
            target="_blank"
            rel="noopener noreferrer"
            className={`no-underline ${(PrivateChat || showCreateWorkspace) ? styles.isbackdrop : ""}`}
          >
            <div className="flex items-center justify-between p-2 hover:bg-[#EDF4FE] dark:hover:bg-[#2A3249] rounded-md cursor-pointer">
              <div className="flex items-center space-x-4">
                <div className="text-gray-600 dark:text-gray-300 flex flex-row items-center justify-center">
                  <RequestFeature theme={theme} />
                </div>
                <div className={classNames("font-inter ", styles.itemText, {
                  [styles.light]: theme === "light",
                  [styles.dark]: theme === "dark",
                })}>
                  <FormattedMessage id="sidebar.dropdown.option5" />
                </div>
              </div>
              <div className="text-gray-600 dark:text-gray-300 flex flex-row items-center justify-center">
                <OpenNewTabIcon theme={theme} />
              </div>
            </div>
          </a>
          <div className={`flex items-center space-x-4 p-2 hover:bg-[#EDF4FE] dark:hover:bg-[#2A3249] rounded-md cursor-pointer ${(PrivateChat || showCreateWorkspace) ? styles.isbackdrop : ""}`}
            onClick={() => {
              setShowConfirmModel(true);
            }}
            data-testid="sidebar-del-all-chat">
            <div className="text-red-500">
              <DeleteConversation />
            </div>
            <div className={classNames("font-inter ", styles.itemText, styles.delConversation)}>
              <FormattedMessage id="delete.all.conversation" />
            </div>
          </div>

          <div className={`flex items-center justify-end p-2 group ${(PrivateChat || showCreateWorkspace) ? styles.isbackdrop : ""}`}>
            <div className={classNames("flex items-center gap-[8px] font-inter cursor-pointer", styles.signOutText, {
              [styles.light]: theme === "light",
              [styles.dark]: theme === "dark",
            })} onClick={onLogout}>
              <Signout theme={theme} />
              <span className="group-hover:underline"><FormattedMessage id="sidebar.dropdown.option6" /></span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SidebarSubOption;